<template>
  <div>
    <div class="main">
      <!-- Main Banner -->
      <emb-home-main-banner-v3
        :data="homeBannerV3Data"
        :data2="featureV2categoryData"
      ></emb-home-main-banner-v3>

      <!-- Key features -->
      <div class="section-gap title-gap">
        <key-features :secTitle="$t('message.KeyFeatures')"></key-features>
      </div>

      <!-- value Proposition -->
      <div class="section-gap title-gap" style="background: #f8f8f8">
        <v-container grid-list-xl>
          <div class="sec-title mb-0">
            <h2>{{ $t("message.valueProposition") }}</h2>
          </div>
          <v-row align="center" justify="center" class="my-3">
            <v-col cols="12">
              <img
                src="/static/images/revised/value-proposition.png"
                alt="Value Proposition"
              />
            </v-col>
          </v-row>
        </v-container>
      </div>

      <!-- Our Approach -->
      <div class="section-gap">
        <v-container grid-list-xl>
          <v-layout row wrap align-center>
            <v-flex xl6 xs12 md5 lg5 py-0>
              <img
                src="/static/images/revised/our-approach.png"
                alt="vission"
              />
            </v-flex>
            <v-flex xl6 xs12 md7 lg7 class="pr-md-12">
              <div class="sec-title mb-4">
                <h2 class="text-left">{{ $t("message.OurApproach") }}</h2>
              </div>
              <p class="font-custom">
                TradeBridge is an AI driven, B2B e-marketplace for
                Agro-Commodities providing farmers, processors & importers
                seamless access to millions of retailers & wholesalers across
                India. TradeBridge does not buy or sell crops and is not a
                broker. Instead, we offer you the ability to effortlessly market
                your commodity via our platform.
              </p>
              <p class="font-custom">
                We have built a complete digital platform for Buyers and
                Vendors; a trade marketplace to buy & sell, without having to
                worry about anything but "Price". We take care of logistics,
                quality inspections, secure payments, returns, grievance
                redressals & extension of credit. We are introducing technology
                to improve food traceability and sustainability, and insurance
                coverage for all the major risks in the agri-business.
              </p>
            </v-flex>

            <v-flex xl6 xs12 md5 lg5 class="pr-md-12">
              <div
                class="d-flex mb-2 justify-start align-start"
                v-for="(usp, key) in usps"
                :key="key"
              >
                <img
                  src="static/images/revised/leaf.png"
                  class="img-fluid"
                  width="19px"
                />
                <h6 class="d-inline-block ml-2 mb-0">{{ usp }}</h6>
              </div>
            </v-flex>

            <v-flex xl6 xs12 md7 lg7 py-0>
              <v-card>
                <iframe
                  width="100%"
                  src="https://www.youtube.com/embed/RyV_SaQB3nY?rel=0"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </div>

      <embCounter></embCounter>
      <!-- User Journey -->
      <div class="section-gap title-gap">
        <v-container grid-list-xl>
          <div class="sec-title text-center">
            <h2 class="mb-0">{{ $t("message.userJourney") }}</h2>
            <p>
              TradeBridge facilitates your Business Purchases in 2C(two clicks)
            </p>
          </div>
          <v-row justify="center" align="center" class="journey-row">
            <v-col md="4" class="journey-columns">
              <img src="static/images/revised/Choose.png" class="img-fluid" />
              <h4>Choose</h4>
              <p>
                Choose the Commodity and Specifications<br />
                of the product you wish to buy
              </p>
            </v-col>

            <v-col md="4" class="journey-columns journey-columns-middle">
              <img src="static/images/revised/Pay.png" class="img-fluid" />
              <h4>Pay</h4>
              <p>for your purchase via easy and <br />secure payment options</p>
            </v-col>
            <v-col md="4" class="journey-columns">
              <img src="static/images/revised/Choose.png" class="img-fluid" />
              <h4>Sit back & relax</h4>
              <p>While we do all the hard work</p>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <!-- User Journey -->
      <div class="section-gap title-gap" style="background: #f8f8f8 !important">
        <v-container grid-list-xl>
          <div class="sec-title text-center">
            <h2 class="mb-0">{{ $t("message.keyClients") }}</h2>
          </div>
          <v-row justify="center" class="">
            <v-col
              cols="4"
              md="2"
              class="clients-list"
              v-for="(i, key) in 24"
              :key="key"
            >
              <v-card class="pa-2">
                <img
                  :src="'static/images/clients/logo' + i + '.png'"
                  class="img-fluid client-image"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <section class="customer-films section-gap">
        <v-container grid-list-xl>
          <div class="sec-title text-center">
            <h2 class="mb-3">What our customers say</h2>
            <p class="customer-films__lead">
              Two short films from people who trade on TradeBridge.
            </p>
          </div>
          <div class="customer-films__grid">
            <article
              v-for="(film, index) in customerFilms"
              :key="film.src"
              class="customer-films__card"
            >
              <div class="customer-films__frame">
                <video
                  ref="customerFilm"
                  :src="film.src"
                  :controls="film.started"
                  playsinline
                  preload="metadata"
                  controlslist="nodownload noplaybackrate"
                  :aria-label="film.title"
                  @play="onFilmPlay(index, $event)"
                ></video>
                <button
                  v-if="!film.started"
                  type="button"
                  class="customer-films__play"
                  :aria-label="'Play ' + film.title"
                  @click="playFilm(index)"
                >
                  <span class="customer-films__play-icon"></span>
                </button>
              </div>
            </article>
          </div>
        </v-container>
      </section>

      <v-lazy transition="fade-transition">
        <embAppDownload
          class="home-app-download"
          secTitle="Download our app"
        ></embAppDownload>
      </v-lazy>

      <feature-v2
        v-if="false"
        :secTitle="$t('message.OurCategories')"
        :data="featureV2categoryData"
      ></feature-v2>

      <emb-feature-product
        v-if="false"
        :secTitle="$t('message.FeaturedProducts')"
        :data="productData"
        class="grey lighten-4"
      ></emb-feature-product>

      <v-lazy transition="fade-transition" min-height="100px" v-if="false">
        <parallexSection secTitle="Our Process"></parallexSection>
      </v-lazy>
    </div>
  </div>
</template>
<script>
// layout components
import HomeMainBannerV3 from "Components/Layouts/Banner/HomeMainBannerV3";

// widgets
import FeatureV2 from "Components/Widgets/FeatureV2";
import FeatureProduct from "Components/Widgets/FeatureProduct";

import parallexSection from "Components/Widgets/parallexSection";
import Counter from "Components/Widgets/Counter";
import AppDownload from "Components/Widgets/AppDownload";
import KeyFeatures from "Components/Widgets/KeyFeatures";
// import Testimonial from "Components/Widgets/Testimonial";

// data
//import homeBannerV3Data from "Assets/data/homeBannerV3Data";
import featureProductData from "Assets/data/featureProductData";
import latestArrivalData from "Assets/data/latestArrivalData";
import TestimonialData from "Assets/data/TestimonialData";
import api from "Api";
import { bus } from "../main";
import initiateService from "../services/initiate.service";

export default {
  components: {
    embHomeMainBannerV3: HomeMainBannerV3,
    embFeatureProduct: FeatureProduct,
    featureV2: FeatureV2,
    parallexSection: parallexSection,
    embAppDownload: AppDownload,
    embCounter: Counter,
    KeyFeatures: KeyFeatures,
    // embTestimonial: Testimonial,
  },
  data() {
    return {
      homeBannerV3Data: [],
      featureProductData,
      latestArrivalData,
      TestimonialData,
      featureV2categoryData: [],
      productData: [],
      customerFilms: [
        {
          title: "Customer story one",
          src: "/static/images/videos/Testimonial 1.mp4",
          started: false,
        },
        {
          title: "Customer story two",
          src: "/static/images/videos/Testimonial  2.mp4",
          started: false,
        },
      ],
      usps: [
        "Unified Marketplace",
        "User Friendly Interface",
        "Unlimited access to Pan India markets",
        "Transparent and Reliable Market information",
        "Integrated and secured payment gateways",
        "Verified buyers and sellers",
        "24x7 Market",
      ],
    };
  },
  created() {
    bus.$on("isLoggedin", () => {
      initiateService.syncmycart();
      this.getProductsData();
    });
  },
  mounted() {
    this.getCategoriesData();
    this.getProductsData();
    this.getBannersData();
    // window.addEventListener("resize", this.getBannersData());
  },
  methods: {
    playFilm(index) {
      const nodes = [].concat(this.$refs.customerFilm || []);
      const video = nodes[index];
      if (video) {
        video.play();
      }
    },
    onFilmPlay(index, event) {
      this.customerFilms[index].started = true;
      const nodes = [].concat(this.$refs.customerFilm || []);
      nodes.forEach((video) => {
        if (video && video !== event.target) {
          video.pause();
        }
      });
    },
    async getCategoriesData() {
      try {
        const response = await api.get(
          process.env.VUE_APP_BASE_API + "/categories?featuredInWebsite=true"
        );

        for (let key in response.data.data) {
          this.featureV2categoryData.push(response.data.data[key]);
        }
        return true;
      } catch (error) {
        return error;
      }
    },
    async getProductsData() {
      try {
        this.productData = [];
        const response = await api.get(
          process.env.VUE_APP_BASE_API + "/products?filter=featured||eq||true"
        );

        for (let key in response.data) {
          if (response.data[key].featured) {
            // remove disabled productsVariations
            response.data[key].productsVariation = response.data[
              key
            ].productsVariation.filter(
              (productsVariation) => productsVariation.enabled
            );
            this.productData.push(response.data[key]);
          }
        }
        return true;
      } catch (error) {
        return error;
      }
    },
    async getBannersData() {
      try {
        const response = await api.get(
          process.env.VUE_APP_BASE_API + "/banners"
        );
        let temp = [];
        for (let key in response.data) {
          if (response.data[key].enabled && window.innerWidth > 1000) {
            temp[key] = {
              image: response.data[key].desktopImage,
              subHeading: response.data[key].name,
              heading: response.data[key].description,
              url: response.data[key].link,
            };
          } else {
            temp[key] = {
              image: response.data[key].mobileImage,
              subHeading: response.data[key].name,
              heading: response.data[key].description,
              url: response.data[key].link,
            };
          }
        }
        this.homeBannerV3Data = temp;
        return true;
      } catch (error) {
        return error;
      }
    },
  },
  metaInfo() {
    return {
      title: "Tradebridge - Connecting Buyers and Sellers in Agro-Food Commodities",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "Discover the leading B2B platform for agro-food commodities. Tradebridge connects buyers and sellers through a seamless auction system, ensuring efficient trade of high-quality products.",
        },
      ],
    };
  }
};
</script>
<style scoped lang="scss">
.journey-row {
  position: relative;
}

.journey-row .journey-columns {
  text-align: center;
  position: relative;
  z-index: 9;
}
.journey-row .journey-columns img.img-fluid {
  max-width: 200px;
}
.clients-list .pa-2.v-card {
  height: 100%;
  align-items: center;
  display: flex;
  justify-content: center;
}

.clients-list .pa-2.v-card img {
  max-height: 67px;
}

.customer-films {
  background: #fff;
  padding-bottom: 0;
}

::v-deep .home-app-download.section-gap {
  padding-top: 2.5rem;
}

.customer-films__lead {
  max-width: 34rem;
  margin: 0.75rem auto 0;
  color: #5c6560;
  font-size: 1.05rem;
  line-height: 1.6;
}

.customer-films__grid {
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-wrap: wrap;
  gap: 32px;
}

.customer-films__card {
  width: min(100%, 300px);
  background: #0f1411;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 18px 40px rgba(18, 32, 18, 0.1);
}

.customer-films__frame {
  position: relative;
  aspect-ratio: 9 / 16;
  background: #0f1411;
}

.customer-films__frame video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #0f1411;
}

.customer-films__play {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: linear-gradient(180deg, rgba(8, 14, 10, 0.08), rgba(8, 14, 10, 0.28));
  cursor: pointer;
}

.customer-films__play-icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #3c9900;
  box-shadow: 0 8px 24px rgba(60, 153, 0, 0.35);
  position: relative;
}

.customer-films__play-icon:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 54%;
  transform: translate(-50%, -50%);
  border-style: solid;
  border-width: 10px 0 10px 16px;
  border-color: transparent transparent transparent #fff;
}

.customer-films__play:hover .customer-films__play-icon,
.customer-films__play:focus .customer-films__play-icon {
  transform: scale(1.05);
}

.customer-films__play:focus {
  outline: none;
}

.customer-films__play:focus .customer-films__play-icon {
  box-shadow: 0 0 0 4px rgba(60, 153, 0, 0.28), 0 8px 24px rgba(60, 153, 0, 0.35);
}
</style>
